<template>
  <div :class="[$style.base, $style[state]]">
    <div :class="$style.circle">
      <SuccessIcon v-if="state === 'success'" />
      <WarningIcon v-else-if="state === 'warning'" />
      <ErrorIcon v-else-if="state === 'error'" />
      <LoadingIcon v-else />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import ErrorIcon from './Error.vue';
import LoadingIcon from './Loading.vue';
import SuccessIcon from './Success.vue';
import WarningIcon from './Warning.vue';

defineProps<{
  state: 'success' | 'warning' | 'error' | 'loading';
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  transition: background-color 0.3s ease;

  .base.success & {
    background-color: var(--success-softer);
  }

  .base.warning & {
    background-color: var(--warning-softer);
  }

  .base.error & {
    background-color: var(--error-softer);
  }

  .base.loading & {
    background-color: var(--action-primary-softer);
  }
}
</style>
